module.exports = __webpack_public_path__ + "50186f374e70013945d9c40483b1f04b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/pawprints.png
// module id = 3369
// module chunks = 0